export const cardHeaderStyles = {
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: '20px',
        paddingRight: '20px',
        height: '50px',
        width: '1030px',
        backgroundColor: '#354759',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',        
    },
    addUserButton: {
        fontSize: '1.05rem',
    },
}